export default {
    lang: {
        name: 'Has parts'
    }
}